import React from 'react';
import { ApiServerEntityIDType } from '@cp/utils/apiServer/types';
import { Stack } from '@cp/ds/src/components/stack';
import { ContentSkeleton } from '@cp/ds/src/components/contentSkeleton';
import { Box } from '@cp/ds/src/components/box';
import { Typography } from '@cp/ds/src/components/typography';
import { ClientContactList, clientContactItemDict } from '@cp/entities/clientContact';
import { ClientContactType } from '@common/model/client/clientContactType';
import { coreClientContactApi } from 'src/entities/clientContact';

export interface ClientContactsProps {
  targetClientId: ApiServerEntityIDType;
  onContactClick?: React.MouseEventHandler;
}
export const ClientContacts: React.FC<ClientContactsProps> = ({ targetClientId, onContactClick }) => {
  const { data: contactsData, isLoading: isContactsLoading } = coreClientContactApi.endpoints.getAnotherClientContacts.useQuery({
    clientId: targetClientId,
  });

  return (
    <Stack sx={{ px: { xs: 2.5, md: 6.25 }, pt: { xs: 1.25, md: 6.25 }, pb: 6.25, width: 500, maxWidth: 1 }}>
      {isContactsLoading || !contactsData ? (
        <ContentSkeleton />
      ) : (
        <>
          <Box sx={{ textAlign: { xs: 'center', md: 'start' }, mb: { xs: 3.75, md: 5 } }}>
            <Typography variant="h6 Bold">Как вам удобнее связаться?</Typography>
          </Box>
          {contactsData.contacts.filter((c) => c.type !== ClientContactType.InnerChat).length ? (
            <ClientContactList
              contacts={contactsData.contacts}
              contactsConfig={clientContactItemDict}
              isMasked={contactsData.isMasked}
              onItemClick={onContactClick}
            />
          ) : (
            <Typography component="div" sx={{ pb: 2 }} variant="h6">
              Наниматель предпочел скрыть свои контакты, пишите пожалуйста в чат, он получит уведомление
            </Typography>
          )}
        </>
      )}
    </Stack>
  );
};
